import { TColors } from '@cian/ui-kit-design-tokens/colors';
import {
  IconMapCar16,
  IconMapHighway16,
  IconMapMetroEkb16,
  IconMapMetroKzn16,
  IconMapWalk16,
  IconMapMetroMsk16,
  IconMapMetroNN16,
  IconMapMetroNovosib16,
  IconMapMetroSam16,
  IconMapMetroSpb16,
  IconMapTrain16,
  IconMapMCD116,
  IconMapMCD216,
  IconMapMCD316,
  IconMapMCD416,
  IconMapMCD516,
  ISVGIconProps,
} from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { toKebabCase } from './utils/toKebabCase';
import { IIcon } from '../../../../../types/chatHeader';

const IconsMap: Record<IIcon['code'], React.FC<ISVGIconProps>> = {
  car: IconMapCar16,
  highway: IconMapHighway16,
  walk: IconMapWalk16,
  metroEkb: IconMapMetroEkb16,
  metroKzn: IconMapMetroKzn16,
  metroMsk: IconMapMetroMsk16,
  metroNn: IconMapMetroNN16,
  metroNovosib: IconMapMetroNovosib16,
  metroSam: IconMapMetroSam16,
  metroSpb: IconMapMetroSpb16,
  train: IconMapTrain16,
  mcd1: IconMapMCD116,
  mcd2: IconMapMCD216,
  mcd3: IconMapMCD316,
  mcd4: IconMapMCD416,
  mcd5: IconMapMCD516,
};

export const CardSubtitleIcon: React.FC<IIcon> = ({ code, color: { semantic } }) => {
  const iconColor = React.useMemo(() => (semantic ? (toKebabCase(semantic) as TColors) : undefined), [semantic]);

  const IconComponent = IconsMap[code];

  return IconComponent ? <IconComponent color={iconColor} /> : null;
};
